document.addEventListener("DOMContentLoaded", function () {
  const cartList = document.querySelector(".pt-cart-list");
  const cartUpdateCallbacks = [];
  let cartUpdateQueued = false;

  function waitForElement(selector, callback, options = {}) {
    const root = options.root || document;
    const timeout = options.timeout || 5000;
    const existing = root.querySelector(selector);

    if (existing) {
      callback(existing);
      return;
    }

    const observer = new MutationObserver(() => {
      const node = root.querySelector(selector);
      if (!node) return;
      observer.disconnect();
      callback(node);
    });

    observer.observe(root === document ? document.body : root, {
      childList: true,
      subtree: true,
    });

    window.setTimeout(() => observer.disconnect(), timeout);
  }

  function scheduleCartUpdate() {
    if (cartUpdateQueued) return;
    cartUpdateQueued = true;

    requestAnimationFrame(() => {
      cartUpdateQueued = false;
      cartUpdateCallbacks.forEach((callback) => callback());
      document.dispatchEvent(new CustomEvent("dyaboo:cart-updated"));
    });
  }

  function registerCartUpdate(callback) {
    if (typeof callback !== "function") return;
    cartUpdateCallbacks.push(callback);
  }

  if (cartList) {
    const cartObserver = new MutationObserver(() => scheduleCartUpdate());
    cartObserver.observe(cartList, { childList: true, subtree: true });
  }

  // Enfocar automáticamente el campo de búsqueda al presionar el botón
  const searchButton = document.querySelector(".pt-dropdown-toggle");
  const searchInput = document.querySelector(".pt-search-input");

  if (searchButton && searchInput) {
    searchButton.addEventListener("click", function () {
      setTimeout(() => {
        searchInput.focus();
      }, 100);
    });
  }

  // Ocultar botón de WhatsApp en página de venta al por mayor
  if (window.location.pathname.includes("/pages/venta-al-por-mayor")) {
    waitForElement("gty-whatsapp-chat-button", (whatsappButton) => {
      whatsappButton.style.display = "none";
    });
  }

  // Esperar modal y activar redirección
  waitForElement(".modal-content .form-default", (formDiv) => {
    formDiv.style.cursor = "pointer";

    if (formDiv.dataset.bound) return;

    formDiv.addEventListener("click", function () {
      window.location.href = "https://dyaboo.com/collections/nuevo";
    });

    formDiv.dataset.bound = "true";
  });

  // Ajuste borde gris al color "Blanco"
  const applyWhiteBorder = () => {
    const whiteOptions = document.querySelectorAll(
      'a.options-color[data-tooltip="Blanco"], a.options-color[data-tooltip="blanco"]',
    );
    if (!whiteOptions || whiteOptions.length === 0) return;

    whiteOptions.forEach((option) => {
      if (!option.classList.contains("white-border-applied")) {
        option.style.border = "1px solid #ccc";
        option.style.boxSizing = "border-box";
        option.classList.add("white-border-applied");
      }
    });
  };

  applyWhiteBorder();
  const whiteBorderObserver = new MutationObserver(() => applyWhiteBorder());
  whiteBorderObserver.observe(document.body, { childList: true, subtree: true });
  window.setTimeout(() => whiteBorderObserver.disconnect(), 5000);

  // Se definen desde theme.liquid
  // const ENABLED_FREE_SHIPPING_NOTICE = ...;
  // const FREE_SHIPPING_THRESHOLD = ...;

  if (ENABLED_FREE_SHIPPING_NOTICE) {
    function formatCurrency(amount) {
      return new Intl.NumberFormat("es-CO", {
        style: "currency",
        currency: "COP",
        minimumFractionDigits: 0,
      }).format(amount);
    }

    function updateFreeShippingNotice() {
      const totalElement = document.querySelector(".pt-cart-total-price");
      const noticeContainer = document.querySelector(".pt-envio-gratis-msg");

      if (!totalElement || !noticeContainer) {
        console.warn("[Envío DYABOO] No se encontró total o contenedor.");
        return;
      }

      const rawText = totalElement.textContent || "";
      const numericValue = parseInt(rawText.replace(/\D/g, ""), 10);
      if (isNaN(numericValue)) return;

      const percent = Math.min(
        (numericValue / FREE_SHIPPING_THRESHOLD) * 100,
        100,
      );
      const missing = FREE_SHIPPING_THRESHOLD - numericValue;

      let mensaje = "";
      if (numericValue >= FREE_SHIPPING_THRESHOLD) {
        mensaje = "🎁 ¡Felicitaciones! Tu envío será gratis 🎉";
      } else {
        mensaje = `Falta poco, adiciona ${formatCurrency(
          missing,
        )} más para conseguir <strong>¡envío GRATIS!</strong>`;
      }

      noticeContainer.innerHTML = `
        <div class="pt-envio-gratis-text">${mensaje}</div>
        <div class="pt-envio-bar">
          <div class="pt-envio-bar-fill" style="width: ${percent}%;">
            <span class="pt-envio-icon">🚚</span>
          </div>
        </div>
      `;

      // Ajuste posición del camión después de pintar
      const icon = noticeContainer.querySelector(".pt-envio-icon");
      if (icon) {
        icon.style.left = `calc(${percent}% - 10px)`;
      }
    }

    if (cartList) {
      registerCartUpdate(updateFreeShippingNotice);
      updateFreeShippingNotice();
    }
  }

  // === Mensaje dinámico para descuentos por volumen (Dr Volume Discounts) ===
  // Ya viene definido desde el <script> en el head

  if (ENABLED_VOLUME_DISCOUNT_NOTICE) {
    function updateVolumeDiscountNotice() {
      const noticeContainer = document.querySelector(
        ".pt-descuento-volumen-msg",
      );
      const itemElements = document.querySelectorAll(".pt-cart-list .pt-item");

      if (!noticeContainer) {
        console.warn("[Volumen DYABOO] ❌ Contenedor no encontrado.");
        return;
      }

      let totalUnidades = 0;
      let validosParaDescuento = true;

      itemElements.forEach((el) => {
        const qtyText = el.querySelector(".pt-quantity");
        if (!qtyText) return;

        const match = qtyText.textContent.match(/\d+/);
        const cantidad = match ? parseInt(match[0], 10) : 1;
        totalUnidades += cantidad;

        const esValido =
          el.getAttribute("data-coleccion") === VOLUME_DISCOUNT_COLLECTION;
        if (!esValido) validosParaDescuento = false;
      });

      console.log(
        `[Volumen DYABOO] Total unidades: ${totalUnidades} | Sólo productos válidos: ${validosParaDescuento}`,
      );

      if (!validosParaDescuento) {
        noticeContainer.textContent = "";
        return;
      }

      if (totalUnidades < 2) {
        noticeContainer.textContent = VOLUME_MSG_1;
      } else if (totalUnidades === 2) {
        noticeContainer.textContent = VOLUME_MSG_2;
      } else {
        noticeContainer.textContent = VOLUME_MSG_3;
      }
    }

    if (cartList) {
      registerCartUpdate(updateVolumeDiscountNotice);
      updateVolumeDiscountNotice();
    }
  }

  function initRestockRocketIntegration() {
    const productRoots = document.querySelectorAll(".pt-product-single-info");
    if (!productRoots.length) return;

    const selectors = {
      variantInput: 'input.input_variant[name="id"]',
      variantData: ".dyaboo-variant-availability-json",
      addToCartButton: ".btn-addtocart",
      restockSlot: "[data-restock-rocket-slot]",
      restockContainer: ".restock-rocket-button-container",
      swatches: ".pt-swatches-container-js",
    };

    function parseVariantState(root) {
      const dataNode = root.querySelector(selectors.variantData);
      if (!dataNode) return null;

      try {
        const parsed = JSON.parse(dataNode.textContent);
        parsed.variantMap = new Map(
          (parsed.variants || []).map((variant) => [String(variant.id), variant]),
        );
        return parsed;
      } catch (error) {
        console.warn("[DYABOO Restock Rocket] No se pudo leer el JSON de variantes.", error);
        return null;
      }
    }

    function getRestockElements(root) {
      return {
        slot: root.querySelector(selectors.restockSlot),
        container: root.querySelector(selectors.restockContainer),
      };
    }

    function moveRestockButton(root) {
      const { slot, container } = getRestockElements(root);
      if (!slot || !container || container.parentNode === slot) return;
      slot.appendChild(container);
    }

    function getActiveVariant(root, state) {
      const variantInput = root.querySelector(selectors.variantInput);
      if (!variantInput || !state || !state.variantMap) return null;
      return state.variantMap.get(String(variantInput.value)) || null;
    }

    function emitVariantEvents(root, variant) {
      const variantInput = root.querySelector(selectors.variantInput);
      if (!variantInput || !variant) return;

      const detail = {
        productId: root.dataset.productId || null,
        variant,
      };

      variantInput.dispatchEvent(new Event("change", { bubbles: true }));
      document.dispatchEvent(new CustomEvent("variant:change", { detail }));
      document.dispatchEvent(new CustomEvent("product:variant-change", { detail }));
      document.dispatchEvent(new CustomEvent("theme:variant:change", { detail }));
      window.dispatchEvent(new CustomEvent("theme:variant:change", { detail }));
    }

    function updateVisualState(root, variant) {
      const addToCartButton = root.querySelector(selectors.addToCartButton);
      const addToCartColumn = addToCartButton ? addToCartButton.closest(".col-item") : null;
      const { slot, container } = getRestockElements(root);
      const isAvailable = !variant || Boolean(variant.available);

      moveRestockButton(root);

      if (addToCartColumn) {
        addToCartColumn.style.display = isAvailable ? "" : "none";
      } else if (addToCartButton) {
        addToCartButton.style.display = isAvailable ? "" : "none";
      }

      if (slot) {
        slot.style.display = isAvailable ? "none" : "";
      }

      if (container) {
        container.style.display = isAvailable ? "none" : "";
      }
    }

    function syncRoot(root, variantOverride) {
      const state = root._dyabooRestockRocketState || parseVariantState(root);
      if (!state) return;

      root._dyabooRestockRocketState = state;
      root.dataset.productId = String(state.productId || "");

      const variant = variantOverride || getActiveVariant(root, state);
      if (!variant) return;

      const variantId = String(variant.id);
      if (root.dataset.activeVariantId !== variantId) {
        root.dataset.activeVariantId = variantId;
        emitVariantEvents(root, variant);
      }

      updateVisualState(root, variant);
    }

    window.DyabooRestockRocket = window.DyabooRestockRocket || {};
    window.DyabooRestockRocket.syncProductPageVariant = function (root, variant) {
      if (!root) return;
      syncRoot(root, variant || null);
    };

    productRoots.forEach((root) => {
      const variantInput = root.querySelector(selectors.variantInput);
      if (!variantInput) return;

      const swatches = root.querySelector(selectors.swatches);
      const appObserver = new MutationObserver(() => syncRoot(root));
      appObserver.observe(root, { childList: true, subtree: true });

      const inputObserver = new MutationObserver(() => syncRoot(root));
      inputObserver.observe(variantInput, {
        attributes: true,
        attributeFilter: ["value"],
      });

      variantInput.addEventListener("change", () => syncRoot(root));

      if (swatches) {
        swatches.addEventListener("click", () => {
          requestAnimationFrame(() => syncRoot(root));
        });
        swatches.addEventListener("change", () => syncRoot(root));
      }

      syncRoot(root);
    });
  }

  initRestockRocketIntegration();
});
